// export const baseApiUrl = 'http://localhost:1287'
export const baseApiUrl = 'https://www.visaoalpha.com.br:1287'
export const userKey = '__visao_alpha'
export const token = 'sk@iwo@$@!1333$@!'
export const globalPassword = "Vis@oAlpha1234"
export const BaseWpUrl = "http://localhost:3000"


export default { baseApiUrl, userKey, token, globalPassword }